import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { IMG_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditMeterModule = () => {
    const [inReading, setInReading] = useState('');
    const [outReading, setOutReading] = useState('');
    const [date, setDate] = useState('');
    const [inImage, setInImage] = useState(null);
    const [outImage, setOutImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [existingInImage, setExistingInImage] = useState('');
    const [existingOutImage, setExistingOutImage] = useState('');
    const navigate = useNavigate();
    const { id } = useParams(); // Get the id from URL

    // Helper function to format date to 'YYYY-MM-DD' for input type="date"
    const formatDateForInput = (dateString) => {
        const dateObj = new Date(dateString);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Fetch the existing data when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}metermodule/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setInReading(data.data.in_reading);
                    setOutReading(data.data.out_reading);
                    setDate(formatDateForInput(data.data.date)); // Format date for the input field
                    setExistingInImage(data.data.in_image);
                    setExistingOutImage(data.data.out_image);
                } else {
                    alert('Error fetching meter module data');
                }
            })
            .catch(error => console.error('Error fetching meter module:', error));
    }, [id]);

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'in_reading') setInReading(value);
        if (name === 'out_reading') setOutReading(value);
        if (name === 'date') setDate(value);
    };

    // Handle file inputs
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (name === 'in_image') setInImage(files[0]);
        if (name === 'out_image') setOutImage(files[0]);
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        formData.append('in_reading', inReading);
        formData.append('out_reading', outReading);
        formData.append('date', date);
        if (inImage) formData.append('in_image', inImage);
        if (outImage) formData.append('out_image', outImage);

        fetch(`${BASE_URL}metermodule/${id}`, {
            method: 'PUT',
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data.status === 1) {
                    alert('Meter module updated successfully');
                    navigate('/MeterModuleList'); // Redirect to the meter module list page
                } else {
                    alert('Failed to update meter module');
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error:', error);
                alert('Error updating meter module');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Meter Module</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Meter Module</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="in_reading" className="form-label">In Reading</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="in_reading"
                                            name="in_reading"
                                            value={inReading}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="out_reading" className="form-label">Out Reading</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="out_reading"
                                            name="out_reading"
                                            value={outReading}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3 d-none">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="date"
                                            name="date"
                                            value={date}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="in_image" className="form-label">In Image</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="in_image"
                                            name="in_image"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                        />
                                        {existingInImage && (
                                            <div className="mt-2">
                                                <img
                                                    src={`${IMG_URL}${existingInImage}`}
                                                    alt="Existing In Image"
                                                    width="100"
                                                    height="100"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="out_image" className="form-label">Out Image</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="out_image"
                                            name="out_image"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                        />
                                        {existingOutImage && (
                                            <div className="mt-2">
                                                <img
                                                    src={`${IMG_URL}${existingOutImage}`}
                                                    alt="Existing Out Image"
                                                    width="100"
                                                    height="100"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? 'Updating...' : 'Update Meter Module'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditMeterModule;
